import styled, { css, keyframes } from 'styled-components';

const rotate = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

export const FilterPanel = styled.form`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacings[10]};
    padding: ${theme.spacings[16]};
    border-radius: ${theme.radius.sm};
  `}
`;

export const FilterRow = styled.div`
  display: flex;
  align-items: flex-end;
`;

export const Separator = styled.div`
  ${({ theme }) => css`
    flex: 1;
    height: 1px;
    background: ${theme.colors.blue700};
    margin-right: ${theme.spacings[16]};
    margin-bottom: 1.6rem;
  `}
`;

export const FilterHeading = styled.div`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacings[12]};
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.spacings[12]};

    span {
      display: inline-flex;
      align-items: center;
      gap: ${theme.spacings[6]};
      color: ${theme.colors.indigo800};
      font-size: ${theme.font.sizes.xs};
      font-weight: ${theme.font.weights.bold};
    }

    svg {
      color: ${theme.colors.blue600};
      font-size: ${theme.font.sizes.md};
    }

    small {
      color: ${theme.colors.gray600};
      font-size: ${theme.font.sizes.xxs};
    }

    @media (max-width: 580px) {
      align-items: flex-start;
      flex-direction: column;
    }
  `}
`;

export const FilterFields = styled.div`
  ${({ theme }) => css`
    width: 50%;
    margin-left: auto;
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: ${theme.spacings[12]};
  `}
`;

export const Field = styled.div`
  ${({ theme }) => css`
    min-width: 14rem;
    flex: 1 1 16rem;
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings[4]};

    label {
      color: ${theme.colors.blueGray700};
      font-size: ${theme.font.sizes.xxs};
      font-weight: ${theme.font.weights.semiBold};
    }

    input,
    select {
      width: 100%;
      height: 3.8rem;
      padding: 0 ${theme.spacings[10]};
      border: 1px solid #cdd3df;
      border-radius: ${theme.radius.xs};
      outline: 0;
      background: ${theme.colors.white};
      color: ${theme.colors.gray900};
      font-family: ${theme.font.family.default};
      font-size: ${theme.font.sizes.xs};

      &:focus {
        border-color: ${theme.colors.blue600};
        box-shadow: 0 0 0 3px rgba(1, 122, 198, 0.12);
      }
    }
  `}
`;

export const SubmitButton = styled.button`
  ${({ theme }) => css`
    height: 3.8rem;
    padding: 0 ${theme.spacings[16]};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: ${theme.spacings[6]};
    border-radius: ${theme.radius.xs};
    background: ${theme.colors.blue600};
    color: ${theme.colors.white};
    font-family: ${theme.font.family.default};
    font-size: ${theme.font.sizes.xs};
    font-weight: ${theme.font.weights.bold};
    transition: background 0.2s;

    &:hover:not(:disabled) {
      background: ${theme.colors.blue700};
    }

    &:disabled {
      opacity: 0.65;
    }

    .spinning {
      animation: ${rotate} 0.9s linear infinite;
    }

    @media (max-width: 580px) {
      width: 100%;
    }
  `}
`;

export const ClearButton = styled.button`
  ${({ theme }) => css`
    height: 3.8rem;
    padding: 0 ${theme.spacings[16]};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: ${theme.spacings[6]};
    border: 1px solid ${theme.colors.blue600};
    border-radius: ${theme.radius.xs};
    background: ${theme.colors.white};
    color: ${theme.colors.blue600};
    font-family: ${theme.font.family.default};
    font-size: ${theme.font.sizes.xs};
    font-weight: ${theme.font.weights.bold};
    transition: background 0.2s, border-color 0.2s, color 0.2s;

    &:hover:not(:disabled) {
      border-color: ${theme.colors.blue700};
      background: rgba(1, 122, 198, 0.08);
      color: ${theme.colors.blue700};
    }

    &:disabled {
      opacity: 0.65;
    }

    @media (max-width: 580px) {
      width: 100%;
    }
  `}
`;

export const FormError = styled.p`
  ${({ theme }) => css`
    margin-top: ${theme.spacings[10]};
    text-align: right;
    color: ${theme.colors.error};
    font-size: ${theme.font.sizes.xxs};
  `}
`;
